import React from 'react';

/**
 * Simple placeholder component for empty block states in the builder.
 */
function EmptyPlaceholder(props) {
    const style = { minHeight: props.minHeight || '40px', minWidth: props.minWidth || '10px' };
    if (props.fullWidth) {
        style.width = '100%';
    }
    return <div style={style}>{props.children}</div>
}

export default EmptyPlaceholder;

